import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  incomingMessages: [],
  visibleMessages: [],
};

const liveChatReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return initState;

    case REDUX_ACTIONS.ADD_BATCH_OF_MESSAGES:
      return {
        ...state,
        incomingMessages: payload,
      };

    case REDUX_ACTIONS.ADD_NEXT_MESSAGE: {
      const { visibleMessages } = state;
      const incomingMessages = [...state.incomingMessages];
      const areMessagesLeft = incomingMessages.length > 0;
      const nextMessage = areMessagesLeft ? incomingMessages.splice(0, 1)[0] : null;
      return {
        ...state,
        incomingMessages,
        visibleMessages: areMessagesLeft ? [...visibleMessages, nextMessage] : visibleMessages,
      };
    }

    default:
      return state;
  }
};

export default liveChatReducer;
